<template>
  <div class="loanable-form-bike-state">
    <p>{{ $t("components.loanable.form.bike_state.description") }}</p>
    <i18n path="components.loanable.form.bike_state.download_report_template" tag="p">
      <template #report_template>
        <a :href="$t('resources.bike_state_report_template_url')" target="_blank" download>
          {{ $t("components.loanable.form.bike_state.report_template") }}
          <b-icon icon="download" />
        </a>
      </template>
    </i18n>
    <p>
      {{ $t("components.loanable.form.bike_state.upload_report") }}
    </p>
    <forms-validated-input
      v-model="item.details.report"
      :label="$t('bikes.fields.report') | capitalize"
      name="report"
      type="file"
    />
    <p>{{ $t("components.loanable.form.bike_state.keep_updated") }}</p>
  </div>
</template>

<script>
import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";

export default {
  name: "LoanableFormBikeState",
  components: { FormsValidatedInput },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validatePublishing: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
